import styled, { keyframes, css } from 'styled-components';
import CoreSpinner, { type LoadingSpinnerProps } from '@ovpn/ui/loading-spinner';

import { boxed } from '@sso/shared/hocs';

type SpinnerProps = LoadingSpinnerProps & {
    absolute?: boolean;
    delayed?: boolean;
};

const showAfterDelay = keyframes`
    99% {
        opacity: 0;
    }
    100% {
        opacity: 1;
    }
`;

const StyledSpinner = styled(CoreSpinner)<{ $absolute: boolean; $delayed: boolean }>`
    ${t =>
        t.$absolute &&
        css`
            position: absolute;
            inset: 0;

            margin: auto;
    `}

    ${t =>
        t.$delayed &&
        css`
            opacity: 0;

            animation: 500ms ${showAfterDelay};
            animation-fill-mode: forwards;
    `}
`;

function Spinner({ absolute = false, delayed = false, size = 56, ...props }: SpinnerProps) {
    return <StyledSpinner $absolute={absolute} $delayed={delayed} size={size} {...props} />;
}

export default boxed(Spinner);
